import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const Map: React.FC<SvgIconProps> = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M21.38 7.16997L15.1 1.96997L9.55 6.49997L5.27 2.15997L1 16.64L7.87 21.9L15.13 16.72L22.75 21.25L21.38 7.16997ZM7.32 19.59L2.74 16.08L5.99 5.01997L8.65 7.72997L7.32 19.59ZM14.32 15.31L8.87 19.36L10.14 7.96997L14.36 4.54997L14.32 15.31ZM15.82 15.38L15.87 4.55997L19.95 7.89997L20.95 18.44L15.82 15.38Z" />
  </SvgIcon>
);
